// this file maps the Global Commitment organisation categories to their url codes

const categoryCodes = {
  'Packaging producers and users': 'ppu',
  'Raw material producers - non-compostable plastics': 'rmpncp',
  'Raw material producers - compostable plastics': 'rmpcp',
  'Collecting, sorting and recycling companies': 'csr',
  'Suppliers to the plastic packaging industry': 'sppi',
  Governments: 'gov',
};

module.exports = {
  categoryCodes,
};
